/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/components/cart-request-quote.js
  var _CartRequestQuote = class _CartRequestQuote extends HTMLElement {
    constructor() {
      super();
      this.form = null;
      this.nameField = null;
      this.emailField = null;
      this.messageField = null;
      this.submitButton = null;
      this.originalButtonText = null;
    }
    connectedCallback() {
      this.init();
    }
    init() {
      this.form = this.querySelector("form");
      this.nameField = this.querySelector('input[name="name"]');
      this.emailField = this.querySelector('input[name="email"]');
      this.messageField = this.querySelector('textarea[name="message"]');
      this.submitButton = this.querySelector('button[type="submit"]');
      if (!this.form) return;
      if (this.submitButton) {
        this.originalButtonText = this.submitButton.textContent.trim();
      }
      this.bindEvents();
    }
    bindEvents() {
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      if (this.nameField) {
        this.nameField.addEventListener("blur", () => this.validateRequired(this.nameField));
        this.nameField.addEventListener("input", () => this.clearFieldError(this.nameField));
      }
      if (this.emailField) {
        this.emailField.addEventListener("blur", () => this.validateEmail(this.emailField));
        this.emailField.addEventListener("input", () => this.clearFieldError(this.emailField));
      }
      if (this.messageField) {
        this.messageField.addEventListener("blur", () => this.validateRequired(this.messageField));
        this.messageField.addEventListener("input", () => this.clearFieldError(this.messageField));
      }
    }
    handleSubmit(event) {
      return __async(this, null, function* () {
        event.preventDefault();
        const isValid = this.validateForm();
        if (isValid) {
          this.setButtonLoading();
          try {
            console.log("Form is valid - ready to submit");
            yield this.clearCart();
            this.showSuccessMessage();
          } catch (error) {
            console.error("Error during submission:", error);
          } finally {
            this.removeButtonLoading();
          }
        } else {
          console.log("Form validation failed");
        }
      });
    }
    validateForm() {
      let isValid = true;
      if (!this.validateRequired(this.nameField)) {
        isValid = false;
      }
      if (!this.validateEmail(this.emailField)) {
        isValid = false;
      }
      if (!this.validateRequired(this.messageField)) {
        isValid = false;
      }
      return isValid;
    }
    validateRequired(field) {
      if (!field) return true;
      const value = field.value.trim();
      const isValid = value.length > 0;
      if (!isValid) {
        this.showFieldError(field, "This field is required");
      } else {
        this.clearFieldError(field);
      }
      return isValid;
    }
    validateEmail(field) {
      if (!field) return true;
      const value = field.value.trim();
      if (!this.validateRequired(field)) {
        return false;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValid = emailRegex.test(value);
      if (!isValid) {
        this.showFieldError(field, "Please enter a valid email address");
      } else {
        this.clearFieldError(field);
      }
      return isValid;
    }
    showFieldError(field, message) {
      if (!field) return;
      field.classList.add("form__field--error");
      field.setAttribute("aria-invalid", "");
      this.clearFieldError(field, false);
      const errorElement = document.createElement("div");
      errorElement.className = "form__error-message";
      errorElement.textContent = message;
      field.parentNode.appendChild(errorElement);
    }
    clearFieldError(field, removeErrorClass = true) {
      if (!field) return;
      if (removeErrorClass) {
        field.classList.remove("form__field--error");
        field.removeAttribute("aria-invalid", "");
      }
      const existingError = field.parentNode.querySelector(".form__error-message");
      if (existingError) {
        existingError.remove();
      }
    }
    showSuccessMessage() {
      this.form.reset();
      this.form.classList.add("hidden");
      const modalHeader = this.querySelector(".modal__header");
      if (modalHeader) {
        modalHeader.classList.add("hidden");
      }
      const thankYouMessage = this.querySelector(".cart-request__thank-you-message");
      if (thankYouMessage) {
        thankYouMessage.classList.remove("hidden");
      }
    }
    clearFormInputs() {
      var _a;
      if (this.nameField) {
        this.nameField.value = "";
        this.nameField.classList.remove("is-filled");
      }
      if (this.emailField) {
        this.emailField.value = "";
        this.emailField.classList.remove("is-filled");
      }
      if (this.messageField) {
        this.messageField.value = "";
        this.messageField.classList.remove("is-filled");
      }
      this.resetValidation();
      const successMessage = (_a = this.form) == null ? void 0 : _a.querySelector(".form__success-message");
      if (successMessage) {
        successMessage.remove();
      }
    }
    // Public method to reset form validation state
    resetValidation() {
      const fields = [this.nameField, this.emailField, this.messageField];
      fields.forEach((field) => {
        if (field) {
          this.clearFieldError(field);
        }
      });
    }
    // Set loading state on submit button
    setButtonLoading() {
      if (!this.submitButton) return;
      this.submitButton.classList.add("button--loading");
      this.submitButton.disabled = true;
      this.submitButton.setAttribute("aria-busy", "true");
      this.submitButton.textContent = "Submitting...";
    }
    // Remove loading state from submit button
    removeButtonLoading() {
      if (!this.submitButton) return;
      this.submitButton.classList.remove("button--loading");
      this.submitButton.disabled = false;
      this.submitButton.removeAttribute("aria-busy");
      if (this.originalButtonText) {
        this.submitButton.textContent = this.originalButtonText;
      }
    }
    // Clear the Shopify cart via AJAX
    clearCart() {
      return __async(this, null, function* () {
        try {
          const response = yield fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            }
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { detail: { scrollToTop: true } })
          );
          console.log("Cart cleared successfully");
          return true;
        } catch (error) {
          console.error("Error clearing cart:", error);
          document.dispatchEvent(new CustomEvent("cart:error", {
            detail: { error: error.message }
          }));
          return false;
        }
      });
    }
  };
  __name(_CartRequestQuote, "CartRequestQuote");
  var CartRequestQuote = _CartRequestQuote;
  var cart_request_quote_default = CartRequestQuote;

  // src/js/components/product-availability.js
  var productAvailability = /* @__PURE__ */ (() => {
    function init() {
      const product_availability_block = document.querySelector(".product-availability");
      if (!product_availability_block) return;
      const options = Array.from(product_availability_block.querySelectorAll(".option"));
      let activeOption = null;
      options.forEach((option) => {
        option.addEventListener("click", () => {
          handleSelection(option);
        });
      });
      selectOption();
      window.addEventListener("custom:preferred-location-changed", (e) => {
        if (e.detail.source === "product-availability-block") return;
        selectOption();
      });
      function selectOption() {
        const savedLocationId = localStorage.getItem("preferred-location-id");
        const option = options.find((option2) => option2.getAttribute("data-preferred-location-id") === savedLocationId);
        if (option) handleSelection(option, true);
      }
      __name(selectOption, "selectOption");
      function handleSelection(option, silent) {
        if (option === activeOption) return;
        const locationId = option.getAttribute("data-preferred-location-id");
        activeOption == null ? void 0 : activeOption.classList.remove("selected");
        option.classList.add("selected");
        activeOption = option;
        if (!silent) {
          localStorage.setItem("preferred-location-id", locationId);
          window.dispatchEvent(new CustomEvent("custom:preferred-location-changed", {
            detail: {
              source: "product-availability-block"
            }
          }));
        }
        if (document.querySelector(".template-cart .line-item")) updateCartLineItemAvailability();
        if (document.querySelector(".product-availability")) disableAddToCartBtn();
      }
      __name(handleSelection, "handleSelection");
    }
    __name(init, "init");
    function getPreferredDelivery() {
      return localStorage.getItem("preferred-location-id");
    }
    __name(getPreferredDelivery, "getPreferredDelivery");
    function updateCartLineItemAvailability() {
      const line_item_preferred_delivery_blocks = document.querySelectorAll(".line-item__product-availability");
      const preferred_delivery_all_labels = document.querySelectorAll(".line-item__product-availability [data-preferred-location-id]");
      const preferred_delivery = getPreferredDelivery();
      preferred_delivery_all_labels.forEach((label) => label.classList.add("hidden"));
      line_item_preferred_delivery_blocks.forEach((line_item_preferred_delivery_block) => {
        const preferred_delivery_label = line_item_preferred_delivery_block.querySelector(`[data-preferred-location-id="${preferred_delivery}"]`);
        if (preferred_delivery_label) preferred_delivery_label.classList.remove("hidden");
      });
      toggleCheckoutAvailability();
    }
    __name(updateCartLineItemAvailability, "updateCartLineItemAvailability");
    function toggleCheckoutAvailability() {
      const disabledLineItems = document.querySelectorAll(".availability-label.product-inventory-out-of-stock:not(.hidden)");
      const checkoutBtn = document.querySelector('[name="checkout"]');
      if (!checkoutBtn) return false;
      const shouldDisable = disabledLineItems.length > 0;
      checkoutBtn.disabled = shouldDisable;
      toggleCartAlert(shouldDisable);
    }
    __name(toggleCheckoutAvailability, "toggleCheckoutAvailability");
    function disableAddToCartBtn() {
      const selectedInStock = document.querySelector(".product-availability .option.selected .in-stock");
      const addToCartBtn = document.querySelector('[data-action="add-to-cart"]');
      if (!addToCartBtn) return false;
      addToCartBtn.disabled = !selectedInStock;
    }
    __name(disableAddToCartBtn, "disableAddToCartBtn");
    function toggleCartAlert(show) {
      const availabilityAlert = document.querySelector(".availability-alert-box");
      if (!availabilityAlert) return false;
      availabilityAlert.classList.toggle("hidden", !show);
    }
    __name(toggleCartAlert, "toggleCartAlert");
    return {
      init,
      disableAddToCartBtn
    };
  })();
  Shopify.theme.productAvailability = productAvailability;
  var product_availability_default = productAvailability;

  // src/js/components/trending-products.js
  var trendingProducts = (() => {
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var soundOn = false;
    try {
      soundOn = window.sessionStorage.getItem("cogsTrendingSound") === "on";
    } catch (e) {
    }
    function rememberSound(on) {
      soundOn = on;
      try {
        window.sessionStorage.setItem("cogsTrendingSound", on ? "on" : "off");
      } catch (e) {
      }
      Array.prototype.forEach.call(document.querySelectorAll("[data-trending-sound]"), function(button) {
        button.setAttribute("aria-pressed", String(on));
        button.setAttribute("aria-label", on ? button.dataset.labelOff : button.dataset.labelOn);
      });
    }
    __name(rememberSound, "rememberSound");
    var PLAY_AT = 0.35;
    var TAKE_SOUND_BY = 0.15;
    function setupSection(section) {
      if (section.dataset.trendingReady === "true") return;
      section.dataset.trendingReady = "true";
      var media = section.querySelectorAll("[data-trending-media]");
      if (!media.length) return;
      function hydrate(video) {
        if (video.dataset.trendingHydrated === "true") return;
        video.dataset.trendingHydrated = "true";
        Array.prototype.forEach.call(video.querySelectorAll("source[data-src]"), function(source) {
          source.src = source.dataset.src;
          source.removeAttribute("data-src");
        });
        video.load();
      }
      __name(hydrate, "hydrate");
      var items = [];
      Array.prototype.forEach.call(media, function(wrap) {
        items.push({ wrap, video: wrap.querySelector("[data-trending-video]"), ratio: 0 });
      });
      var owner = null;
      function itemFor(el) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].wrap === el) return items[i];
        }
        return null;
      }
      __name(itemFor, "itemFor");
      function chooseOwner() {
        var best = null;
        items.forEach(function(item) {
          if (item.ratio < PLAY_AT) return;
          if (!best || item.ratio > best.ratio) best = item;
        });
        if (!best) {
          owner = null;
          return;
        }
        if (!owner || owner.ratio < PLAY_AT) {
          owner = best;
          return;
        }
        if (best !== owner && best.ratio > owner.ratio + TAKE_SOUND_BY) owner = best;
      }
      __name(chooseOwner, "chooseOwner");
      function unlockForSound() {
        items.forEach(function(item) {
          var video = item.video;
          if (!video || video.dataset.trendingUnlocked === "true") return;
          video.dataset.trendingUnlocked = "true";
          var attempt = video.play();
          if (!attempt || !attempt.then) return;
          attempt.then(function() {
            if (item.ratio < PLAY_AT && !video.paused) {
              video.pause();
              video.muted = true;
            }
          }).catch(function() {
          });
        });
      }
      __name(unlockForSound, "unlockForSound");
      function startPlayback(item) {
        var video = item.video;
        hydrate(video);
        var attempt = video.play();
        if (!attempt || !attempt.catch) return;
        attempt.catch(function() {
          if (!video.muted) {
            video.muted = true;
            rememberSound(false);
            var retry = video.play();
            if (retry && retry.catch) {
              retry.catch(function() {
                waitForMedia(item);
              });
            }
            return;
          }
          waitForMedia(item);
        });
      }
      __name(startPlayback, "startPlayback");
      function waitForMedia(item) {
        var video = item.video;
        if (video.dataset.trendingWaiting === "true") return;
        video.dataset.trendingWaiting = "true";
        video.addEventListener("loadeddata", /* @__PURE__ */ __name(function once() {
          video.removeEventListener("loadeddata", once);
          video.dataset.trendingWaiting = "false";
          if (item.ratio < PLAY_AT || !video.paused) return;
          var again = video.play();
          if (again && again.catch) again.catch(function() {
          });
        }, "once"));
      }
      __name(waitForMedia, "waitForMedia");
      function render() {
        items.forEach(function(item) {
          var playing = item.ratio >= PLAY_AT;
          item.wrap.classList.toggle("is-playing", playing);
          var video = item.video;
          if (!video) return;
          if (!playing) {
            if (!video.paused) video.pause();
            if (!video.muted) video.muted = true;
            return;
          }
          var shouldMute = !(soundOn && item === owner);
          if (video.muted !== shouldMute) video.muted = shouldMute;
          if (video.paused) startPlayback(item);
        });
      }
      __name(render, "render");
      Array.prototype.forEach.call(section.querySelectorAll("[data-trending-sound]"), function(button) {
        button.addEventListener("click", function() {
          var wrap = button.closest ? button.closest("[data-trending-media]") : null;
          var item = wrap ? itemFor(wrap) : null;
          unlockForSound();
          rememberSound(button.getAttribute("aria-pressed") !== "true");
          if (item) {
            owner = item;
            if (item.video) hydrate(item.video);
          }
          render();
        });
      });
      if (reduced) {
        Array.prototype.forEach.call(media, function(wrap) {
          var video = wrap.querySelector("[data-trending-video]");
          if (!video) return;
          hydrate(video);
          video.setAttribute("controls", "controls");
          video.removeAttribute("tabindex");
          var state = wrap.querySelector("[data-trending-state]");
          if (state) state.parentNode.removeChild(state);
          var sound = wrap.querySelector("[data-trending-sound]");
          if (sound) sound.parentNode.removeChild(sound);
        });
        return;
      }
      if (!("IntersectionObserver" in window)) {
        Array.prototype.forEach.call(media, function(wrap) {
          var video = wrap.querySelector("[data-trending-video]");
          if (video) hydrate(video);
        });
        items.forEach(function(item) {
          item.ratio = 1;
        });
        owner = items[0] || null;
        render();
        return;
      }
      var loader = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            var video = entry.target.querySelector("[data-trending-video]");
            if (video) hydrate(video);
            loader.unobserve(entry.target);
          });
        },
        { rootMargin: "400px 0px" }
      );
      var player = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            var item = itemFor(entry.target);
            if (item) item.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          });
          chooseOwner();
          render();
        },
        { threshold: [0, 0.15, 0.35, 0.5, 0.75, 0.9, 1] }
      );
      Array.prototype.forEach.call(media, function(wrap) {
        loader.observe(wrap);
        player.observe(wrap);
      });
      document.addEventListener("visibilitychange", function() {
        if (!document.hidden) return;
        items.forEach(function(item) {
          item.ratio = 0;
        });
        owner = null;
        render();
      });
    }
    __name(setupSection, "setupSection");
    function init(root) {
      var sections = (root || document).querySelectorAll("[data-trending]");
      if (!sections.length) return;
      Array.prototype.forEach.call(sections, setupSection);
      rememberSound(soundOn);
    }
    __name(init, "init");
    return { init };
  })();
  var trending_products_default = trendingProducts;

  // src/js/components/header-location-selector.js
  var headerLocationSelector = /* @__PURE__ */ (() => {
    const init = /* @__PURE__ */ __name(() => {
      const selectors = Array.from(document.querySelectorAll(".header__action-item--location"));
      if (!selectors.length) return;
      const changeEventName = "custom:preferred-location-changed";
      const localStorageKey = "preferred-location-id";
      const selectorObjs = selectors.map((selector) => {
        var _a;
        return {
          input: selector.querySelector("input"),
          initialSelection: (_a = selector.querySelector("input")) == null ? void 0 : _a.value,
          options: Array.from(selector.querySelectorAll('button[name="location_id"]')),
          selectionLabel: selector.querySelector(".location-selector__value")
        };
      });
      selectorObjs.forEach((selectorObj, idx) => {
        selectorObj.options.forEach((option) => {
          option.addEventListener("click", () => {
            handleSelection(option, false, true);
          });
        });
        if (idx === 0) {
          const savedLocationId = localStorage.getItem(localStorageKey);
          if (!savedLocationId) {
            localStorage.setItem(localStorageKey, selectorObj.initialSelection);
          } else if (savedLocationId != selectorObj.initialSelection) {
            const correctOption = selectorObj.options.find((option) => option.getAttribute("value") == savedLocationId);
            if (correctOption) {
              handleSelection(correctOption, false, true);
            } else {
              localStorage.setItem(localStorageKey, initialSelection);
              window.dispatchEvent(new CustomEvent(changeEventName, {
                detail: {
                  source: "header-location-selector"
                }
              }));
            }
          }
        }
      });
      window.addEventListener(changeEventName, (e) => {
        var _a;
        if (((_a = e.detail) == null ? void 0 : _a.source) === "header-location-selector") return;
        const savedLocationId = localStorage.getItem(localStorageKey);
        const correctOption = selectorObjs[0].options.find((option) => option.getAttribute("value") == savedLocationId);
        if (correctOption) handleSelection(correctOption, true, true);
      });
      function handleSelection(selectedOption, silent, updateOthers) {
        const selectorObjUsed = selectorObjs.find((selectorObj) => selectorObj.options.includes(selectedOption));
        const activeOption = selectorObjUsed.options.find((option) => option.hasAttribute("aria-current"));
        activeOption == null ? void 0 : activeOption.removeAttribute("aria-current");
        const value = selectedOption.getAttribute("value");
        selectorObjUsed.input.value = value;
        selectorObjUsed.selectionLabel.innerHTML = selectedOption.innerHTML;
        selectedOption.setAttribute("aria-current", true);
        if (!silent) {
          localStorage.setItem(localStorageKey, value);
          window.dispatchEvent(new CustomEvent(changeEventName, {
            detail: {
              source: "header-location-selector"
            }
          }));
        }
        if (updateOthers) {
          selectorObjs.forEach((selectorObj) => {
            if (selectorObj !== selectorObjUsed) {
              const matchingOption = selectorObj.options.find((option) => option.getAttribute("value") == value);
              if (matchingOption) handleSelection(matchingOption, true, false);
            }
          });
        }
        document.body.click();
      }
      __name(handleSelection, "handleSelection");
    }, "init");
    return {
      init
    };
  })();
  var header_location_selector_default = headerLocationSelector;

  // src/js/components/collection-location-selector.js
  var collectionLocationSelector = /* @__PURE__ */ (() => {
    const init = /* @__PURE__ */ __name(() => {
      var _a;
      const locationsJSON = document.querySelector("#collection-location-selector-data");
      const locations = JSON.parse((locationsJSON == null ? void 0 : locationsJSON.textContent) || "[]");
      if (!locations.length) return;
      const hdLocationId = (_a = locations.find((location) => location.name === "Home Delivery")) == null ? void 0 : _a.id;
      const deliveryTruckIcon = `<svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke="#000000" stroke-width="0.648" class="icon-delivery-truck"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Delivery_Truck" data-name="Delivery Truck"> <g> <path d="M21.47,11.185l-1.03-1.43a2.5,2.5,0,0,0-2.03-1.05H14.03V6.565a2.5,2.5,0,0,0-2.5-2.5H4.56a2.507,2.507,0,0,0-2.5,2.5v9.94a1.5,1.5,0,0,0,1.5,1.5H4.78a2.242,2.242,0,0,0,4.44,0h5.56a2.242,2.242,0,0,0,4.44,0h1.22a1.5,1.5,0,0,0,1.5-1.5v-3.87A2.508,2.508,0,0,0,21.47,11.185ZM7,18.935a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,7,18.935Zm6.03-1.93H9.15a2.257,2.257,0,0,0-4.3,0H3.56a.5.5,0,0,1-.5-.5V6.565a1.5,1.5,0,0,1,1.5-1.5h6.97a1.5,1.5,0,0,1,1.5,1.5ZM17,18.935a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,17,18.935Zm3.94-2.43a.5.5,0,0,1-.5.5H19.15a2.257,2.257,0,0,0-4.3,0h-.82v-7.3h4.38a1.516,1.516,0,0,1,1.22.63l1.03,1.43a1.527,1.527,0,0,1,.28.87Z"></path> <path d="M18.029,12.205h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"></path> </g> </g> </g></svg>`;
      const clickAndCollectIcon = `<svg height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000" stroke="#000000" stroke-width="7.68" class="icon-click-and-collect"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g> <path style="fill:#000000;" d="M490.259,0H21.741C9.783,0,0,9.783,0,21.741v468.518C0,502.217,9.783,512,21.741,512h121.75 h226.106h121.75c10.87,0,20.654-9.783,20.654-21.741V21.741C512,9.783,502.217,0,490.259,0z M164.144,469.605V251.108h183.711 v218.497H164.144z M469.605,469.605h-77.181V229.367c0-11.958-9.783-21.741-21.741-21.741H143.49 c-11.958,0-21.741,9.783-21.741,21.741v240.238H43.482V43.482h426.123V469.605z"></path> <path style="fill:#000000;" d="M192.408,145.665h128.272c11.958,0,21.741-8.696,22.828-21.741 c0-11.958-9.783-21.741-21.741-21.741H192.408c-11.958,0-21.741,9.783-21.741,21.741 C170.667,135.881,180.45,145.665,192.408,145.665z"></path> </g> </g> </g> </g></svg>`;
      const arrowRightIcon = `<svg focusable="false" class="icon-arrow-right" viewBox="0 0 8 12" role="presentation"><path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path></svg>`;
      const closeIcon = `<svg focusable="false" class="icon-close" viewBox="0 0 12 12" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.414 6l4.243 4.243-1.414 1.414L6 7.414l-4.243 4.243-1.414-1.414L4.586 6 .343 1.757 1.757.343 6 4.586 10.243.343l1.414 1.414L7.414 6z" fill="currentColor"></path></svg>`;
      const element = document.createElement("div");
      element.classList.add("collection-location-selector");
      element.innerHTML = `
            <div class="cls__mobile-summary">
                ${deliveryTruckIcon}
                <span>Home Delivery</span>
                ${arrowRightIcon}
            </div>
            <div class="cls__content-wrapper">
                <div class="cls__content">
                    <div class="cls__label">
                        <span>Show availability for</span>
                        <div class="cls__close">
                            ${closeIcon}
                        </div>
                    </div>
                    <div class="cls__options">
                        <div class="cls__option" data-preferred-location-id="${hdLocationId}">
                            ${deliveryTruckIcon}
                            <span>Home Delivery</span>
                            ${arrowRightIcon}
                        </div>
                        ${locations.map((location) => {
        if (location.name === "Home Delivery") return "";
        return `
                                <div class="cls__option" data-preferred-location-id="${location.id}">
                                    ${clickAndCollectIcon}
                                    <span><span class="cls__mobile-summary-prefix">Collect at </span>${location.name}</span>
                                    ${arrowRightIcon}
                                </div>
                            `;
      }).join("")}
                    </div>
                </div>
            </div>
        `;
      let elapsed = 0;
      const interval = setInterval(() => {
        elapsed += 200;
        const host = document.querySelector("#gf-controls-container");
        const filter = document.querySelector('[data-filter-type="variant:metafield:custom:inventory_filter_options"]');
        if (host && filter) {
          host.appendChild(element);
          activate(element);
          clearInterval(interval);
        } else if (elapsed >= 1e4) {
          clearInterval(interval);
        }
      }, 200);
      function activate(element2) {
        const mobileSummary = element2.querySelector(".cls__mobile-summary");
        const close = element2.querySelector(".cls__close");
        const contentWrapper = element2.querySelector(".cls__content-wrapper");
        const options = Array.from(element2.querySelectorAll(".cls__option"));
        let activeOption = null;
        options.forEach((option) => {
          option.addEventListener("click", () => {
            handleSelection(option);
            togglePopup();
          });
        });
        selectOption();
        window.addEventListener("custom:preferred-location-changed", (e) => {
          if (e.detail.source === "collection-location-selector") return;
          selectOption();
        });
        [mobileSummary, close].forEach((button) => {
          button.addEventListener("click", () => {
            togglePopup();
          });
        });
        contentWrapper.addEventListener("click", (e) => {
          if (e.target === contentWrapper) togglePopup();
        });
        function togglePopup() {
          const popupOpen = element2.hasAttribute("data-popup-open");
          if (window.innerWidth <= 640 || popupOpen) {
            element2.toggleAttribute("data-popup-open", !popupOpen);
            document.documentElement.toggleAttribute("data-locator-popup-open", !popupOpen);
          }
        }
        __name(togglePopup, "togglePopup");
        function selectOption() {
          const savedLocationId = localStorage.getItem("preferred-location-id");
          const option = options.find((option2) => option2.getAttribute("data-preferred-location-id") === savedLocationId);
          if (option) handleSelection(option, true);
        }
        __name(selectOption, "selectOption");
        function handleSelection(option, silent) {
          if (option === activeOption) return;
          element2.setAttribute("data-disabled", true);
          const locationId = option.getAttribute("data-preferred-location-id");
          const previousId = activeOption == null ? void 0 : activeOption.getAttribute("data-preferred-location-id");
          activeOption == null ? void 0 : activeOption.classList.remove("selected");
          option.classList.add("selected");
          activeOption = option;
          mobileSummary.innerHTML = option.innerHTML;
          if (!silent) {
            localStorage.setItem("preferred-location-id", locationId);
            window.dispatchEvent(new CustomEvent("custom:preferred-location-changed", {
              detail: {
                source: "collection-location-selector"
              }
            }));
          }
          const activeFilter = previousId ? document.querySelector(`.selected-item [data-fvalue="${previousId}"]`) : null;
          activeFilter == null ? void 0 : activeFilter.click();
          const alreadyActive = !!document.querySelector(`.selected-item [data-fvalue="${locationId}"]`);
          const filterOption = document.querySelector(`[data-filter-type="variant:metafield:custom:inventory_filter_options"] [data-fvalue="${locationId}"]`);
          if (filterOption && !alreadyActive) {
            filterOption.click();
            const interval2 = setInterval(() => {
              const activated = document.querySelector(`.selected-item [data-fvalue="${locationId}"]`);
              if (activated) {
                element2.removeAttribute("data-disabled");
                clearInterval(interval2);
              }
            }, 50);
          } else {
            element2.removeAttribute("data-disabled");
          }
        }
        __name(handleSelection, "handleSelection");
      }
      __name(activate, "activate");
    }, "init");
    return {
      init
    };
  })();
  var collection_location_selector_default = collectionLocationSelector;

  // src/js/components/plp-product-availability.js
  var plpProductAvailability = /* @__PURE__ */ (() => {
    const init = /* @__PURE__ */ __name(() => {
      const locationsJSON = document.querySelector("#collection-location-selector-data");
      const locations = JSON.parse((locationsJSON == null ? void 0 : locationsJSON.textContent) || "[]");
      if (!locations.length) return;
      const activeIcon = `
            <span class="option-icon icon-active">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" fill="#0A7A0A"/><path d="M4.5 8.5L7 11L11.5 5.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
        `;
      const inactiveIcon = `
            <span class="option-icon icon-inactive">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" fill="#B5B5B5"/><path d="M6 6L14 14M14 6L6 14" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
            </span>
        `;
      const changeEventName = "custom:preferred-location-changed";
      const hdLocation = locations.find((location) => location.name === "Home Delivery");
      const _PLPProductAvailability = class _PLPProductAvailability extends HTMLElement {
        constructor() {
          super();
          this.render = this.render.bind(this);
        }
        connectedCallback() {
          setTimeout(() => {
            const productLocationsJSON = this.querySelector('script[type="application/json"]');
            const productLocations = JSON.parse((productLocationsJSON == null ? void 0 : productLocationsJSON.textContent) || "[]");
            if (!productLocations.length) return;
            this.productLocations = productLocations;
            this.render();
            window.addEventListener(changeEventName, this.render);
          }, 0);
        }
        disconnectedCallback() {
          window.removeEventListener(changeEventName, this.render);
        }
        render() {
          const preferredLocationId = localStorage.getItem("preferred-location-id");
          if (!preferredLocationId) return;
          const productHdLocation = this.productLocations.find((location) => location.id == (hdLocation == null ? void 0 : hdLocation.id));
          const hdAvailable = productHdLocation && productHdLocation.qty > 0;
          const productCcLocations = locations.filter((location) => location.id !== hdLocation.id).map((location) => {
            const match = this.productLocations.find((productLocation) => productLocation.id == location.id);
            return __spreadProps(__spreadValues({}, location), {
              available: match && match.qty > 0
            });
          });
          let ccAvailable = false;
          let ccLocationName = "";
          if (preferredLocationId == hdLocation.id) {
            ccAvailable = !!productCcLocations.find((location) => location.available);
          } else {
            const ccLocation = productCcLocations.find((location) => location.id == preferredLocationId);
            if (ccLocation) {
              ccLocationName = ccLocation.name;
              ccAvailable = ccLocation.available;
            }
          }
          this.innerHTML = `
                    <div class="availability-option ${hdAvailable ? "active" : ""}">
                        ${hdAvailable ? activeIcon : inactiveIcon}
                        <span class="label">Home Delivery</span>
                    </div>
                    <div class="availability-option ${ccAvailable ? "active" : ""}">
                        ${ccAvailable ? activeIcon : inactiveIcon}
                        <span class="label">Click & Collect${ccLocationName ? ` - ${ccLocationName}` : ""}</span>
                    </div>
                `;
        }
      };
      __name(_PLPProductAvailability, "PLPProductAvailability");
      let PLPProductAvailability = _PLPProductAvailability;
      customElements.define("plp-product-availability", PLPProductAvailability);
    }, "init");
    return {
      init
    };
  })();
  var plp_product_availability_default = plpProductAvailability;

  // src/js/main.js
  (function() {
    customElements.define("cart-request-quote", cart_request_quote_default);
    trending_products_default.init();
    document.addEventListener("shopify:section:load", (event) => {
      trending_products_default.init(event.target);
    });
    window.addEventListener("load", (event) => {
      header_location_selector_default.init();
      if (window.location.pathname.includes("/products/") || window.location.pathname.includes("/cart")) {
        product_availability_default.init();
      }
      if (window.location.pathname.includes("/collections/")) {
        collection_location_selector_default.init();
        plp_product_availability_default.init();
      }
    });
  })();
})();
